<template>
    <div class="row">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: "CityComponent",
};
</script>

<style scoped>

</style>
